<template>
    <div class="scrollable only-y">
        <div :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="page-header card-base card-shadow--medium">
                <h2 class="no-m white-text">
                    Monitoring
                </h2>
            </div>
        </div>
        <el-card>
            <el-tabs v-model="tabs" type="border-card" v-loading="loadingPage">
                <el-tab-pane label="Usage Session" name="usageSession">
                    <el-col>
                        <el-row>
                            <el-col>
                                <el-select
                                    size="medium"
                                    class="mr-20"
                                    clearable
                                    v-model="filterCompany"
                                    @change="filterCompanyName"
                                    filterable
                                    placeholder="Company Name"
                                >
                                    <el-option
                                        v-for="items in listCustomer"
                                        :key="items.customer_id"
                                        :label="items.customer_name"
                                        :value="items.customer_id"
                                    ></el-option>
                                </el-select>
                                <el-select
                                    size="medium"
                                    class="mr-20"
                                    clearable
                                    v-model="filterPhoneNumber"
                                    placeholder="Phone Number"
                                    :disabled="!filterCompany ? true : false"
                                >
                                    <el-option
                                        v-for="(items, idx) in listPhoneNumber"
                                        :key=idx
                                        :label="items ? items : '-'"
                                        :value="items"
                                    ></el-option>
                                </el-select>
                                <el-date-picker
                                    style="width:320px;"
                                    v-model="selectedStartDate"
                                    range-separator="-"
                                    size="medium"
                                    type="daterange"
                                    :picker-options="pickerOptions"
                                    placeholder="Pick a day"
                                    class="mr-20"
                                >
                                </el-date-picker>
                                <el-button
                                    type="primary"
                                    size="medium"
                                    style="width: 100px;"
                                    @click="getUsageSession"
                                    :loading="btnSearchLoading"
                                >
                                    Search
                                </el-button>
                            </el-col>
                        </el-row>
    
                        <el-row>
                            <el-table 
                                height="250"
                                v-loading="loadingTable"
                                element-loading-text="Loading..."
                                element-loading-spinner="el-icon-loading" 
                                class="mt-30"
                                :data="monitoringUsage"
                            >
                                <el-table-column prop="market_area_customer" label="Market Area" width="180">
                                    <template slot-scope="props">
                                        <div
                                            style="height: 13em;"
                                        >
                                            <p v-if="props.row.master_market_area_name">{{ props.row.master_market_area_name }}</p>
                                            <p v-else>-</p>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column property="conversation_type" label="Conversation Type" width="200">
                                    <div
                                        style="height: 13em;"
                                    >
                                        <table>
                                            <tr style="background-color: transparent;">
                                                <td style="border: none;">Authentication</td>
                                            </tr>
                                            <tr style="background-color: transparent;">
                                                <td style="border: none;">Marketing</td>
                                            </tr>
                                            <tr style="background-color: transparent;">
                                                <td style="border: none;">Utility</td>
                                            </tr>
                                            <tr style="background-color: transparent;">
                                                <td style="border: none;">Service</td>
                                            </tr>
                                        </table>
                                    </div>
                                </el-table-column>
                                <el-table-column property="postpaid_limit" label="Postpaid Limit" width="200">
                                    <template slot-scope="props">
                                        <div
                                            style="height: 13em;"
                                        >
                                            <table>
                                                <tr style="background-color: transparent;">
                                                    <td style="border: none;">{{
                                                        props.row.is_authentication_max
                                                            ? 'Max'
                                                            : props.row.authentication_limit
                                                    }}</td>
                                                </tr>
                                                <tr style="background-color: transparent;">
                                                    <td style="border: none;">{{
                                                        props.row.is_marketing_max
                                                            ? 'Max'
                                                            : props.row.marketing_limit
                                                    }}</td>
                                                </tr>
                                                <tr style="background-color: transparent;">
                                                    <td style="border: none;">{{
                                                        props.row.is_utility_max
                                                            ? 'Max'
                                                            : props.row.utility_limit
                                                    }}</td>
                                                </tr>
                                                <tr style="background-color: transparent;">
                                                    <td style="border: none;">{{
                                                        props.row.is_service_max
                                                            ? 'Max'
                                                            : props.row.service_limit
                                                    }}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column property="postpaid_usage" label="Postpaid Usage" width="200">
                                    <template slot-scope="props">
                                        <div
                                            style="height: 13em;"
                                        >
                                            <table>
                                                <tr style="background-color: transparent;">
                                                    <td style="border: none;">
                                                        {{props.row.authentication_usage - props.row.authentication_topup_usage}}
                                                    </td>
                                                </tr>
                                                <tr style="background-color: transparent;">
                                                    <td style="border: none;">
                                                        {{props.row.marketing_usage - props.row.marketing_topup_usage}}
                                                    </td>
                                                </tr>
                                                <tr style="background-color: transparent;">
                                                    <td style="border: none;">
                                                        {{props.row.utility_usage - props.row.utility_topup_usage}}
                                                    </td>
                                                </tr>
                                                <tr style="background-color: transparent;">
                                                    <td style="border: none;">
                                                        {{props.row.service_usage - props.row.service_topup_usage}}
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column property="creadit_balance" label="Creadit Balance" width="200">
                                    <template slot-scope="props">
                                        <div
                                            style="height: 13em;"
                                        >
                                            <table>
                                                <tr style="background-color: transparent;">
                                                    <el-tooltip
                                                        class="box-item"
                                                        effect="dark"
                                                        placement="top"
                                                    >
                                                        <template #content>
                                                            Balance : {{ props.row.authentication_quota }}<br />
                                                            Usage : {{ props.row.authentication_topup_usage }}<br/>
                                                            Credit : {{ props.row.authentication_credit }}
                                                        </template>
                                                        <td style="border: none;">{{props.row.authentication_quota}}</td>
                                                    </el-tooltip>
                                                </tr>
                                                <tr style="background-color: transparent;">
                                                    <el-tooltip
                                                        class="box-item"
                                                        effect="dark"
                                                        placement="top"
                                                    >
                                                        <template #content>
                                                            Balance : {{ props.row.marketing_quota }}<br />
                                                            Usage : {{ props.row.marketing_topup_usage }}<br/>
                                                            Credit : {{ props.row.marketing_credit }}
                                                        </template>
                                                        <td style="border: none;">{{props.row.marketing_quota}}</td>
                                                    </el-tooltip>
                                                </tr>
                                                <tr style="background-color: transparent;">
                                                    <el-tooltip
                                                        class="box-item"
                                                        effect="dark"
                                                        placement="top"
                                                    >
                                                        <template #content>
                                                            Balance : {{ props.row.utility_quota }}<br />
                                                            Usage : {{ props.row.utility_topup_usage }}<br/>
                                                            Credit : {{ props.row.utility_credit }}
                                                        </template>
                                                        <td style="border: none;">{{props.row.utility_quota}}</td>
                                                    </el-tooltip>
                                                </tr>
                                                <tr style="background-color: transparent;">
                                                    <el-tooltip
                                                        class="box-item"
                                                        effect="dark"
                                                        placement="top"
                                                    >
                                                        <template #content>
                                                            Balance : {{ props.row.service_quota }}<br />
                                                            Usage : {{ props.row.service_topup_usage }}<br/>
                                                            Credit : {{ props.row.service_credit }}
                                                        </template>
                                                        <td style="border: none;">{{props.row.service_quota}}</td>
                                                    </el-tooltip>
                                                </tr>
                                            </table>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column property="free_entry" label="Free Entry" width="200">
                                    <template slot-scope="props">
                                        <div
                                            style="height: 13em;"
                                        >
                                            <table>
                                                <tr style="background-color: transparent;">
                                                    <td style="border: none;">{{props.row.authentication_ctwa}}</td>
                                                </tr>
                                                <tr style="background-color: transparent;">
                                                    <td style="border: none;">{{props.row.marketing_ctwa}}</td>
                                                </tr>
                                                <tr style="background-color: transparent;">
                                                    <td style="border: none;">{{props.row.utility_ctwa}}</td>
                                                </tr>
                                                <tr style="background-color: transparent;">
                                                    <td style="border: none;">{{props.row.service_ctwa}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column property="total_usage" label="Total Usage" width="200">
                                    <template slot-scope="props">
                                        <div
                                            style="height: 13em;"
                                        >
                                            <table>
                                                <tr style="background-color: transparent;">
                                                    <td style="border: none;">{{props.row.authentication_usage}}</td>
                                                </tr>
                                                <tr style="background-color: transparent;">
                                                    <td style="border: none;">{{props.row.marketing_usage}}</td>
                                                </tr>
                                                <tr style="background-color: transparent;">
                                                    <td style="border: none;">{{props.row.utility_usage}}</td>
                                                </tr>
                                                <tr style="background-color: transparent;">
                                                    <td style="border: none;">{{props.row.service_usage}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column property="trafic_type" label="Traffic Type" width="200">
                                    <template slot-scope="props">
                                        <div
                                            style="height: 13em;"
                                            v-if="dataUsage.length > 0 && dataUsage[props.$index].traffic_type"
                                        >
                                            <table
                                                v-for="(item, idx) in dataUsage[props.$index].traffic_type"
                                                :key="idx"
                                            >
                                                <tr style="background-color: transparent;">
                                                    <td style="border: none; text-transform: capitalize;">{{ item.type }}</td>
                                                </tr>
                                            </table>
                                        </div>
                                        <p v-else>-</p>
                                    </template>
                                </el-table-column>
                                <el-table-column property="trafic_transaction" label="Traffic Transaction" width="200">
                                    <template slot-scope="props">
                                        <div
                                            style="height: 13em;"
                                            v-if="dataUsage.length > 0 && dataUsage[props.$index].traffic_type"
                                        >
                                            <table
                                                v-for="(item, idx) in dataUsage[props.$index].traffic_type"
                                                :key="idx"
                                            >
                                                <tr style="background-color: transparent;">
                                                    <td style="border: none;">{{ item.doc_count }}</td>
                                                </tr>
                                            </table>
                                        </div>
                                        <p v-else>-</p>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-row>
                    </el-col>
                </el-tab-pane>
            </el-tabs>
        </el-card>
        <el-card class="mt-20 mb-20 card-base" style="border:none; color:white;">
            DAM Corp.
        </el-card>
	</div>
</template>
<script>
import api from '@/networkClient'
import config from '@/config'
const moment = require('moment')
export default {
    data(){
        return {
            fillNumb:'',
            numberCustomer: [],
            loadingDetail: false,
            detail: [],
            dialogFormVisible: false,
            detailNumber: '',
            formLabelWidth: '200px',
            loadingSync: false,
            pickerOptions: {
				disabledDate: this.disabledDate
			},
            selectedStartDate: [
                moment().format("YYYY-MM-DD"),
                moment().format("YYYY-MM-DD")
            ],
            totalTrx: 0,
            currentPage: 1,
            tabs:'usageSession',
            today: moment().format("dddd, DD MMM YYYY"),
            getToday: moment().format('DD MMM YYYY'),
            getMonth: moment().month()+1,
            selectedMonth: moment().format("YYYY-MM"),
            btnLoading: false,
            dataBilling: this.billing,
            loadingInv: false,
            dataTotalBilling:this.totalBilling,
            dataNumber: this.number,
            options: [], 
            table:[],
            trx: [],
            dataUsage:[],
            loading: {
                trx: false
            },
            listCustomer: [],
            listPhoneNumber: [],
            filterCompany: '',
            filterPhoneNumber: '',
            dataUsage: [],
            monitoringUsage: [],
            btnSearchLoading: false,
            loadingTable: false,
            loadingPage: false
        }
    },
    methods: {
        log(data) {
            console.log(data, " <<data");
        },
        async filterCompanyName() {
            await this.loadWA(this.filterCompany);
            this.filterPhoneNumber = '';
        },
        disabledDate(date) {
			// console.log('date disable', date);
			var today = moment(), diff = today.diff(moment(date), 'd')
						if(moment(date) < moment('2022-02')|| diff < 0){
							return true
						} else {
							if(diff == 0){
								if(today.isSame(moment(date), 'd') == false){
									return true
								} else {
									return false
								}
							}
							return false
						}
			// return new Date() < date
		},
        formatDate(val, format){
            return moment(val).local().format(format)
        },
        paginate(page){
            this.currentPage = page
            this.getTrx(page)
        },
        countRatio(val1,val2,val3){
            let count = Number(val1)/(Number(val2) + Number(val3)) * 100

            count = count ? Math.floor(count) : 0

            if (isFinite(count) && count <= 100) {
                count += '%'
            }
            else {
                count = '~%'
            }
            return count
        },
        print() {
			window.print()
        },
        capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
                if(string.split("_").length > 0){
                    let title = []
                    _.map(string.split("_"), (str) => {
                        title.push(str.charAt(0).toUpperCase() + str.slice(1))
                    })
                    return title.join(" ")
                } else {
                    return string.charAt(0).toUpperCase() + string.substring(1);
                }
			}
        },
        formatNumber(value) {
			// let val = (value/1).toFixed(2).replace('.', ',')
			return value.toLocaleString('id-ID')
        },
        async changeFilter(){
			await this.getBilling()
        },
        async getBilling(query = ""){
            this.loadingPage=true;
            this.table = []
            this.numberCustomer = []
            this.btnLoading = true
            // console.log("selected month is",this.selectedMonth)
            this.loadingInv = true
            let custId = this.$route.params.consumen
            let apiOptions = {
                url: config.baseApi + 'consumen/' + custId + "/monthly_usage",
                method: 'post',
                data:{
                    months: this.selectedMonth,
                    with_date: false
                },
                timeout: (10 * 60) * 1000
            }
            if(query == "download"){
                apiOptions.url += "?download"
                apiOptions.responseType = 'blob'
            }
            await api(
                apiOptions
            )
            .then(res => {
                let tempNumber = new Array()
                let tempBilling = new Array()
                let i = 0
                let date = ""
                if(res.data.ec == 200 || query == "download"){
                    if(res.headers['content-type'].indexOf('application/json') == -1){
                        try {
							if(moment(this.selectedMonth).format("M") == this.getMonth){
								date = this.getToday
							}
							else{
								date = moment(this.selectedMonth).endOf('month').format("DD MMM YYYY")
							}
							const url = window.URL.createObjectURL(new Blob([res.data], { type: res.headers['content-type'] }));
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', 'Report Billing (Platform by DAMCorp)('+date+').xls'); //or any other extension
							link.click();
						} catch(err){
                            // console.log()
							// console.log(err.message)
						}
                    }
                    else{
                        this.dataTotalBilling = 0

                        res.data.data.dataUser.forEach(element => {
                            this.numberCustomer.push({value: element.phone_number, label: element.phone_number})
                        });

                        if (res.data.data.detail) {
                            let datas = res.data.data.detail.count_limit || []

                            if (datas.length > 0) {
                                datas = datas.map(el => {
                                    if (el) {
                                        if (el.productName && el.productName.toLowerCase() == 'whatsapp conversation') {
                                            el.cbp_usage = el.cbp_usage || 0
                                            el.bi_usage = el.bi_usage || 0
                                            el.ui_usage = el.ui_usage || 0
                                            el.international_usage = el.international_usage || 0
    
                                            switch (el.productType) {
                                                case 'notification':
                                                    el.productType = 'CBP Invoice'
                                                    break;
                                                case 'notification_caping':
                                                    el.productType = 'CBP Caping'
                                                    break;
                                                case 'notification_caping_plafon':
                                                    el.productType = 'CBP Hybrid'
                                                    break;
                                            }
    
                                            
                                        }
    
                                        let findTraffic = res.data.data.detail.traffic.find(val => el.customerNumber == val.phone_number) || null
    
                                        el.traffic = findTraffic.traffic
                                    }

                                    return el
                                })

                                datas = datas.filter(v => v != null)
                            }

                            this.table = datas
                            // console.log(this.table);
                        }
                    }
                } else {
                    // this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                }
                this.btnLoading = false
                this.loadingInv = false
            })
            .catch(err => {
                console.log(err)
                this.$swal(this.$t('error'), this.$t('error_text'), "error")
                this.btnLoading = false
				this.loadingInv = false
            })
            this.loadingPage=false;
        },
        checkLoadingSync(data){
            if (data.customerNumber == this.detailNumber) {
                return true
            }
            else {
                return false
            }
        },
        async syncData(query = ""){
            
            // console.log("selected month is",this.selectedMonth)
            let custId = this.$route.params.consumen

            let apiOptions = {
                url: config.baseApi + 'consumen/' + custId + "/jobQuota",
                method: 'post',
                data:{
                    months: moment(this.selectedMonth).format('YYYY-MM'),
                    force: true
                },
                timeout: (10 * 60) * 1000
            }

            this.$swal({
              title: `Are you sure want to sync data in (${moment(this.selectedMonth).format('MMM YYYY')})?`,
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, sure!',
              cancelButtonText: 'No',
              showCloseButton: true,
              showLoaderOnConfirm: true
            }).then(async () => {
                this.loadingSync = true
                await api(
                    apiOptions
                )
                .then(res => {
                    if (res.data.ec == 200 && res.data.data.detail) {
                        let today = moment().format('YYYY-MM')
                        if (moment(this.selectedMonth).format('YYYY-MM') != today) {
                            this.syncDataBilling()
                        }
                        else{
                            this.$swal(this.$t('success'), this.$t('success'), "success")
                            this.getBilling()
                            this.loadingSync= false
                        }
                    }
                    // this.loadingSync= false
                })
                .catch(err => {
                    console.log(err)
                    this.$swal(this.$t('error'), this.$t('error_text'), "error")
                    this.btnLoading = false
                    this.loadingSync= false
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Syncronize canceled'
                });
            });
            
        },
        async syncDataBilling(query = ""){
            this.loadingSync = true
            // console.log("selected month is",this.selectedMonth)
            let custId = this.$route.params.consumen
            let apiOptions = {
                url: config.baseApi + 'consumen/' + custId + "/new_billing",
                method: 'post',
                data:{
                    months: moment(this.selectedMonth).format('YYYY-MM'),
                    billing:true,
                    sync: true
                },
                timeout: (10 * 60) * 1000
            }
            await api(
                apiOptions
            )
            .then(res => {
                if (res.data.ec == 200 && res.data.data.length > 0){
                        this.$swal(this.$t('success'), this.$t('success'), "success")
                }
                else{
                    this.$swal(this.$t('error'), "Error sync data billing", "error")
                }
                this.getBilling()
                this.loadingSync= false
            })
            .catch(err => {
                console.log(err)
                this.$swal(this.$t('error'), this.$t('error_text'), "error")
                this.btnLoading = false
				this.loadingSync= false
            })
        },
        async getDataSync(query = ""){
            this.detailNumber = ""
            if(!this.selectedStartDate[0] || !this.selectedStartDate[1]) {
                return
            }
            this.btnLoading = true
            // console.log("selected month is",this.selectedMonth)
            this.loadingInv = true
            let custId = this.$route.params.consumen
            let apiOptions = {
                url: config.baseApi + 'consumen/' + custId + "/sync_usage",
                method: 'post',
                data:{
                    "startDate":moment(this.selectedStartDate[0]).format("YYYY-MM-DD"),
                    "endDate":moment(this.selectedStartDate[1]).format("YYYY-MM-DD"),
                    "number": this.fillNumb
                },
                timeout: (10 * 60) * 10000
            }
            if(query == "download"){
                apiOptions.url += "?download"
                apiOptions.responseType = 'blob'
            }
            await api(
                apiOptions
            )
            .then(res => {
                let tempNumber = new Array()
                let tempBilling = new Array()
                let i = 0
                let date = ""
                if(res.data.ec == 200 || query == "download"){
                    if(res.headers['content-type'].indexOf('application/json') == -1){
                        try {
							if(moment(this.selectedMonth).format("M") == this.getMonth){
								date = this.getToday
							}
							else{
								date = moment(this.selectedMonth).endOf('month').format("DD MMM YYYY")
							}
							const url = window.URL.createObjectURL(new Blob([res.data], { type: res.headers['content-type'] }));
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', 'Report Billing (Platform by DAMCorp)('+date+').xls'); //or any other extension
							link.click();
						} catch(err){
                            // console.log()
							// console.log(err.message)
						}
                    }
                    else{
                        let data = []

                        data = res.data.data.dataUser.map((el,i) => {
                            // this.numberCustomer.push({value: el.phone_number, label: el.phone_number })
                            let product = el.product.find(v => v.productName.toLowerCase() == 'whatsapp conversation')
                            let traffic = res.data.data.traffic.find(val => val.phone_number == el.phone_number)
                            let tempData = {
                                no: `${i+1}.`,
                                fbbm_id: product ? product.fbbm_id : '-',
                                customerName: res.data.data.companyName,
                                customerNumber: el.phone_number,
                                bi_dam: 0,
                                ui_dam:0,
                                total_dam: 0,
                                bi_fb: 0,
                                ui_fb: 0,
                                total_fb: 0,
                                running: traffic.running || null
                                // traffic: traffic ? traffic.traffic: null,
                                // quota: traffic ? traffic.quota:null
                            }

                            if (traffic) {
                                tempData.bi_dam = traffic.quota.national.cbp.bi + traffic.quota.national.bi + traffic.quota.international.bi
                                tempData.ui_dam = traffic.quota.national.cbp.ui + traffic.quota.national.ui + traffic.quota.international.ui
                                tempData.total_dam = tempData.bi_dam + tempData.ui_dam
                                tempData.bi_fb = traffic.fb_bi || 0
                                tempData.ui_fb = traffic.fb_ui || 0
                                tempData.total_fb = tempData.bi_fb + tempData.ui_fb
                            }

                            if (tempData.total_fb <= tempData.total_dam) {
                                tempData.running = true
                            }

                            return tempData
                        })
                        
                        this.dataUsage = data

                        // console.log(this.table);
                    }
                } else {
                    // this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                }
                this.btnLoading = false
                this.loadingInv = false
            })
            .catch(err => {
                console.log(err)
                this.btnLoading = false
				this.loadingInv = false
            })
        },
        async usageSync(data){
            if(!this.selectedStartDate[0] || !this.selectedStartDate[1]) {
                return
            }
            let custId = this.$route.params.consumen
            this.detailNumber = data.customerNumber
            this.loadingDetail = true
            this.$swal({
              title: `Are you sure want to sync data usage for number (${data.customerNumber})?`,
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, sure!',
              cancelButtonText: 'No',
              showCloseButton: true,
              showLoaderOnConfirm: true
            }).then(() => {
                 let apiOptions = {
                    url: config.baseApi + 'consumen/' + custId + "/insert_sync_usage",
                    method: 'post',
                    data:{
                        "startDate":moment(this.selectedStartDate[0]).format("YYYY-MM-DD"),
                        "endDate":moment(this.selectedStartDate[1]).format("YYYY-MM-DD"),
                        "number": data.customerNumber
                    },
                    timeout: (10 * 60) * 1000
                }

                api(
                    apiOptions
                )
                .then(res => {
                    if(res.data.ec == 200){
                        this.$swal(this.$t('success'), this.$t('success'), "success")
                    } else {
                        this.$swal(this.$t('error'), this.$t('error_text'), "error")
                    }
                    this.getDataSync()
                    this.loadingDetail = false
                })
                .catch(err => {
                    console.log(err)
                    this.loadingDetail = false
                    this.$message({
                        type: 'warning',
                        message: `Syncronize error: ${err}`
                    });
                })
            }).catch(() => {
                this.loadingDetail = false
                this.$message({
                    type: 'info',
                    message: 'Syncronize canceled'
                });
                // this.additionalServiceLoadingButton = false
            });
        },
        async detailSync(data){
            if(!this.selectedStartDate[0] || !this.selectedStartDate[1]) {
                return
            }
            this.loadingDetail = true
            this.dialogFormVisible = true
            this.detailNumber = data.customerNumber
            let custId = this.$route.params.consumen
            let apiOptions = {
                url: config.baseApi + 'consumen/' + custId + "/get_sync_usage",
                method: 'post',
                data:{
                    "startDate":moment(this.selectedStartDate[0]).format("YYYY-MM-DD"),
                    "endDate":moment(this.selectedStartDate[1]).format("YYYY-MM-DD"),
                    "number": data.customerNumber
                },
                timeout: (10 * 60) * 1000
            }

            await api(
                apiOptions
            )
            .then(res => {
                if(res.data.ec == 200){
                    let datas = res.data.data

                    if (datas.length > 0) {
                        datas = datas.map((el,i) => {
                            el.no = `${i+1}.`
                            switch (el.status) {
                                case 0:
                                    el.status = "Waiting"
                                    break;
                                case 1:
                                    el.status = "In Progress"
                                    break;
                                case 2:
                                    el.status = "Done"
                                    break;
                                case 3:
                                    el.status = "Failed"
                                    break;
                            }

                            return el
                        })
                    }

                    this.detail = datas
                } else {
                    this.$swal(this.$t('error'), this.$t('error_text'), "error")
                    this.dialogFormVisible = false
                }
                this.loadingDetail = false
            })
            .catch(err => {
                console.log(err)
                this.loadingDetail = false
            })

        },
        async getTrx(page=1, per_page=10){
            this.loading.trx = true
            let custId = this.$route.params.consumen
            let apiOptions = {
                url: config.baseApi + 'finance/' + custId + "/mutation",
                method: 'get',
                params:{
                    page: page,
                    per_page: per_page
                },
                timeout: (10 * 60) * 1000
            }
            // if(query == "download"){
            //     apiOptions.url += "?download"
            //     apiOptions.responseType = 'blob'
            // }
            await api(
                apiOptions
            ).then(res => {
                this.trx = res.data.data.mutation_data
                this.totalTrx = res.data.data.total
                this.loading.trx = false
            }).catch(err => {
                console.log("err",err)
                this.loading.trx = false
            })
        },
        async getUsageSession(){
            this.btnSearchLoading=true;
            this.loadingTable=true;
            let custId = this.filterCompany;
            let data = {
                startDate: this.selectedStartDate[0],
                endDate: this.selectedStartDate[1],
                phone_number: this.filterPhoneNumber
            };

            let apiOptions = {
                url: config.baseApi + `master-consumen/${custId}/daily_usage`,
                method: 'POST',
                data: data
            }
            
            await api(
                apiOptions
            ).then(res => {
                const data =
                    res &&
                    res.data &&
                    res.data.data &&
                    res.data.data.traffic
                        ? res.data.data.traffic
                        : [];
                const status =
                    res &&
                    res.data &&
                    res.data.ec
                        ? res.data.ec
                        : null;

                if (status === 200) {
                    let monitoring = data.filter(item => item.phone_number === this.filterPhoneNumber);
                    let usageArr = monitoring.length > 0 ? monitoring[0].usgArr : [];
					let dataMonitoring = monitoring.length > 0 ? monitoring[0].monitoring : [];
					this.monitoringUsage = dataMonitoring;
					this.dataUssage = usageArr;
                }
                this.btnSearchLoading=false;
                this.loadingTable=false;
            }).catch(err => {
                console.log("err",err);
                this.btnSearchLoading=false;
                this.loadingTable=false;
            })
        },
        clear(){
            this.selectedMonth = ''
            this.getBilling()
        },
        async loadConsumen() {
            await api({
                url: config.baseApi + "notification/consumen",
                method: 'get',
                params: {
                    customer_type: 2
                }
            })
            .then(res => {
                let data =
                    res &&
                    res.data &&
                    res.data.data &&
                    res.data.data.consumen
                        ? res.data.data.consumen
                        : [];
                let status =
                    res &&
                    res.data &&
                    res.data.ec
                        ? res.data.ec
                        : null;
				if(status === 200){
					this.listCustomer = data;
				}
            })
            .catch(err => {
                console.error(err);
            })
        },
        async loadWA(id) {
			await api({
				method: 'post',
				url: config.baseApi +'user/'+id+'/detail_number'
			}).then(result => {
                const status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;
                const data =
                    result &&
                    result.data &&
                    result.data.data
                        ? result.data.data
                        : [];
				if(status == 200){
                    this.listPhoneNumber = data;
				} else {
                    this.listPhoneNumber = [];
                }
			}).catch(error => {
                console.log('Error:', error)
			})
		}
    },
    async beforeMount(){
        let d = new Date(2022,2);
        d.setDate(d.getDate()-1);
        
		for(let i = 6; i >= 0; i--){
			// console.log("a", moment().subtract(i, 'month').format("MM YYYY"))
            let data = {
				value: moment().subtract(i, 'month').format("YYYY-MM"),
				label: moment().subtract(i, 'month').format("MMM YYYY")
			}

            if (data.value <  moment(d).format("YYYY-MM")) {
                data.disabled = true
            }

			this.options.push(data) 
		}
	},
    async mounted(){
        await this.getBilling()
        await this.getTrx()
        await this.loadConsumen();
    }
}
</script>
<style lang="scss">
.toolbar-mon {
    max-width: 100%;
    margin: 0 auto;
    margin-bottom: 20px;
}
.header-text{
	font-weight: 700;
	color: #000;
	opacity: 0.7;
}

.wa-number{
    font-size: 1em;
}

.el-table {
    .cell-custom {
        padding: 15px 0;
    }

    thead.is-group{
        th {
            text-align: center;
        }    
    } 
        
    // th > .cell {
    //     text-align: center;
    // }
}

.el-table--group::after, .el-table--border::after {
    width: 0%;
}

</style>

